import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "react-tooltip";
function WPQTTooltip({ id }) {
    return (_jsx(Tooltip, { id: id, className: "wpqt-bg-red-600", children: _jsx("span", { children: "Tooltip content" }) }));
}
export { WPQTTooltip };
